import {useState} from 'react';

import useMapLoadedEffect from '~utils/map/events/useMapLoadedEffect';
import {MapRef} from '~types/Map';

export default function useMousePosition(mapRef: MapRef) {
    const [coordinate, setCoordinate] = useState([0, 0]);

    useMapLoadedEffect((map) => {
        map.on('mousemove', ({lngLat}) => setCoordinate(lngLat.toArray()));
    }, mapRef);

    return coordinate;
}
